import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  > .ant-input-search {
    margin-bottom: 16px;
  }
  .ant-input-search {
    width: 300px;
  }
`;

export const TopTagsBox = styled.div`
  padding-top: 16px;
`;
